<div
  class="bg-surface border-weak flex h-10 shrink-0 items-center gap-1.5 border-b px-3 text-[13px]">
  <i [class]="ICONS.link" class="text-text-tertiary"></i>
  @if (notice(); as n) {
    <span class="text-text-secondary truncate">{{
      'assistant.link.' + n | translate
    }}</span>
  } @else {
    <nav
      class="flex min-w-0 items-center gap-1"
      [attr.aria-label]="'assistant.link.label' | translate">
      @for (crumb of link.linked()?.crumbs ?? []; track $index) {
        @if (!$first) {
          <i [class]="ICONS.caretRight" class="text-text-tertiary shrink-0 text-[11px]"></i>
        }
        @if (crumb.link && !$last) {
          <button
            type="button"
            data-testid="link-crumb"
            class="text-text-secondary hover:text-text-primary hover:bg-interactive max-w-48 cursor-pointer truncate rounded-sm px-1 py-0.5 font-medium transition-colors"
            (click)="openCrumb(crumb.link)">
            {{ crumb.label }}
          </button>
        } @else {
          <span
            class="max-w-48 truncate px-1 py-0.5"
            [class]="
              $last ? 'text-text-primary font-semibold' : 'text-text-secondary font-medium'
            "
            [attr.aria-current]="$last ? 'page' : null">
            {{ crumb.label }}
          </span>
        }
      }
    </nav>
  }
  <span class="flex-1"></span>
  <button
    type="button"
    data-testid="return-to-tab"
    class="btn btn-secondary btn-sm shrink-0"
    [disabled]="assistant.anyStreaming()"
    [title]="
      (assistant.anyStreaming() ? 'assistant.wait_for_reply' : 'assistant.return_to_tab')
        | translate
    "
    (click)="returnToTab()">
    <i [class]="ICONS.arrowSquareIn"></i>{{ 'assistant.return_to_tab' | translate }}
  </button>
</div>
<div class="relative flex min-h-0 flex-1">
  @if (assistant.toggleVisible()) {
    <app-assistant-panel />
  } @else if (assistant.accessKnown()) {
    <p class="text-text-secondary p-4 text-sm">{{ 'assistant.unavailable' | translate }}</p>
  } @else {
    <p class="text-text-tertiary p-4 text-sm">{{ 'assistant.loading' | translate }}</p>
  }
  <app-assistant-file-preview />
</div>
